import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const updateMunicipalityPermission = async (token, municipalityPermissionId, params) => {
  const objectName = 'municipality_permission'
  const url = `municipality_permissions/${municipalityPermissionId}`

  return apiPatch({ url, token, objectName, params })
}

export const useToggleHighRisk = ({ options } = {}) => {
  const token = useContext(AuthContext)

  return useMutation(({ municipalityPermissionId, isHighRisk }) => {
    return updateMunicipalityPermission(token, municipalityPermissionId, { is_high_risk: isHighRisk })
  }, { ...options })
}
